module dg.objects {

    import DG_DATA_TYPES = dg.restfulApi.DG_DATA_TYPES;

    interface ICustomDateRangeState {
        startDatepickerOptions: any;
        endDatepickerOptions: any;
        rangeOptions: any;
        adjustEndDateToBeInRange: () => void;
    }

    class MonthState implements ICustomDateRangeState {
        private customDateRangeController: CustomDateRangeController;
        public rangeOptions;

        public startDatepickerOptions;
        public endDatepickerOptions;

        constructor(customDateRangeController: CustomDateRangeController, private moment: any) {
            this.customDateRangeController = customDateRangeController;
            this.startDatepickerOptions = customDateRangeController.startDatepickerOptions;
            this.endDatepickerOptions = customDateRangeController.endDatepickerOptions;
            this.endDatepickerOptions['minMode'] = 'month';
            this.startDatepickerOptions['minMode'] = 'month';
            this.rangeOptions = customDateRangeController.rangeOptions;
        }

        public adjustEndDateToBeInRange = () => {

            this.customDateRangeController.adjustEndDateToBeInRange();

            if (this.customDateRangeController.rangeType == 'CR') {
                this.customDateRangeController.setDatepickerEndDate(this.moment(this.customDateRangeController.valueObj.max).endOf('month').toDate());
            }
        }
    }

    class DateState implements ICustomDateRangeState {
        private customDateRangeController: CustomDateRangeController;
        public rangeOptions;

        public startDatepickerOptions;

        public endDatepickerOptions;

        constructor(customDateRangeController: CustomDateRangeController) {
            this.customDateRangeController = customDateRangeController;
            this.startDatepickerOptions = customDateRangeController.startDatepickerOptions;
            this.endDatepickerOptions = customDateRangeController.endDatepickerOptions;
            this.rangeOptions = customDateRangeController.rangeOptions;
        }

        public adjustEndDateToBeInRange = () => {
            this.customDateRangeController.adjustEndDateToBeInRange();
        }
    }


    export class CustomDateRangeController {

        private instantiated = false;

        public state: ICustomDateRangeState;
        public datePicker = { date: null };
        public maxDate = null;

        public value: dg.domain.model.Range<{}>;
        public propMeta: restfulApi.DomainObjectPropertyMetadata;

        public valueObj: any;

        public startDatepickerOptions: any = {};
        readonly NullValue: dg.domain.model.Range<{}> = {
            min: null,
            max: null,
            domainType: "Range"
        };

        public options: any;
        public startDate: any;
        public endDate: any;

        public endDatepickerOptions = {
            minDate: null,
            maxDate: null,
        };

        public dateRangeValidation: any = null;
        public rangeOptions: any;
        public isRequired: boolean = false;

        public rangeType: any = {};

        public constructor(
            private customDateRangeService: dg.objects.CustomDateRangeService,
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            private moment: any
            
            
        ) {
            this.valueObj = dgUtils.ObjectHelperService.mergeDeep(this.valueObj, this.NullValue);
        }

        public ngModel: ng.INgModelController;

        public domainObjectCtrl: ObjectEditorController;
        public status = {
            startDatepickerOpened: false,
            endDatepickerOpened: false,
            dropdownMenuOpened: false
        };

        private instantiate = () => {
            if (this.propMeta.dataType == DG_DATA_TYPES.DateRange) {
                this.state = new DateState(this);
            }
            else if (this.propMeta.dataType == DG_DATA_TYPES.MonthRange) {
                this.state = new MonthState(this, this.moment);
            }
            else {
                throw new Error(`${this.propMeta.dataType} is not supported by CustomDateRange component`)
            }

            this.instantiated = true;
        }

        $onInit = () => {
            this.rangeOptions = this.customDateRangeService.getDateRangeOptions();

            if (this.propMeta.extensions && this.propMeta.extensions.validation) {
                let rules = this.propMeta.extensions.validation.rules;
                let dateRangeLength = this.customDateRangeService.getValidationRule(rules, 'dateRangeLength');
                if (dateRangeLength) {
                    this.dateRangeValidation = dateRangeLength.params;
                }

                let isRequired = !!this.customDateRangeService.getValidationRule(rules, 'notNull');
                //if (isRequired) {
                //     = true;
                //}
            }

            this.adjustRanges();
        }


        $onChanges = (changes) => {
            if (changes.value) {
                if (!changes.value.currentValue) {
                    this.clearValue();
                }
                else {
                    this.valueObj = dgUtils.ObjectHelperService.mergeDeep(this.valueObj, changes.value.currentValue);
                }

                if (!this.instantiated) {
                    this.instantiate();
                }

                this.adjustRanges();
            }
        }

        public toggleDropdownMenu = (e) => {
            this.$timeout(() => {
                this.status.dropdownMenuOpened = !this.status.dropdownMenuOpened;
            });
        };

        public openStartDatepicker = () => {
            this.$timeout(() => {
                this.status.startDatepickerOpened = true;
            });
        };

        public openEndDatepicker = () => {
            this.$timeout(() => {
                this.status.endDatepickerOpened = true;
            });
        };

        public onSelected = () => {
            if (this.rangeType != 'CR') {
                this.setDatepickerStartDate(this.rangeOptions[this.rangeType].min.toDate());
                this.setDatepickerEndDate(this.rangeOptions[this.rangeType].max.toDate());
                this.updateValue();
            }
            else {
                this.openStartDatepicker();
            }
        }

        public startDatepickerModelChange = () => {
            this.updateValue();
            this.rangeType = 'CR';

            if (!this.valueObj.max) {
                this.openEndDatepicker();

                //this.adjustEndDateToBeInRange();
                //this.updateValue();
            }
        }

        public endDatepickerModelChange = () => {
            this.updateValue();
            this.rangeType = 'CR';
        }

        public updateValue = () => {
            if (this.valueObj.min && this.valueObj.max) {
                this.adjustRanges();
                this.state.adjustEndDateToBeInRange();
                let serverValue = { ...this.valueObj };
                this.ngModel.$setViewValue(serverValue);
            }
            else {
                this.ngModel.$setViewValue(null);
            }
        }

        public clear = () => {
            this.clearValue();
            this.updateValue();
        }

        clearValue() {
            this.valueObj = dgUtils.ObjectHelperService.mergeDeep(this.valueObj, this.NullValue);
            this.rangeType = null;
        }

        adjustRanges = () => {
            if (this.valueObj && this.valueObj.min) {
                let minRange = 1;
                if (this.dateRangeValidation && this.dateRangeValidation.min) {
                    minRange = this.dateRangeValidation.min;
                }
                this.state.endDatepickerOptions.minDate = this.moment(this.valueObj.min)
                    .add(minRange, 'days').toDate();

                if (this.dateRangeValidation && this.dateRangeValidation.max) {
                    this.state.endDatepickerOptions.maxDate = this.moment(this.valueObj.min)
                        .add(this.dateRangeValidation.max, 'days').toDate();
                }

            }
        }

        public adjustEndDateToBeInRange = () => {

            if (this.state.endDatepickerOptions.minDate && this.valueObj.max < this.state.endDatepickerOptions.minDate) {
                this.setDatepickerEndDate(this.state.endDatepickerOptions.minDate);
            }
            else if (this.state.endDatepickerOptions.maxDate && this.valueObj.max > this.state.endDatepickerOptions.maxDate) {
                this.setDatepickerEndDate(this.state.endDatepickerOptions.maxDate);
            }
            else if (!this.valueObj.max) {
                this.setDatepickerEndDate(this.state.endDatepickerOptions.minDate);
            }
        }

        setDatepickerStartDate = (min: any) => {
            this.valueObj.min = min;
        }

        setDatepickerEndDate = (max: any) => {
            this.valueObj.max = max;
        }
    }

    angular.module('dg.objects').component('customDateRange', {
        bindings: {
            value: '<ngModel',
            propMeta: '<',
            options: '<'
        },
        require: {
            ngModel: 'ngModel',
            domainObjectCtrl: '^objectEditor'
        },
        controller: CustomDateRangeController,
        templateUrl: '/digmo/src/objects/properties/date/custom-date-range.html'
    });
}
